import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=db28affa&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db28affa')) {
      api.createRecord('db28affa', component.options)
    } else {
      api.reload('db28affa', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=db28affa&", function () {
      api.rerender('db28affa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-41eEIz398RefR/JS/comp/FavElement.vue"
export default component.exports